import { makeStyles } from "@material-ui/styles";
import cx from "classnames";

const useStyles = makeStyles(theme => ({
  chip: {
    fontSize: "13px",
    lineHeight: "16px",
    color: "#41485A",
    background: "#FFFFFF",
    border: "2px solid #F0F2F8",
    boxShadow: "0px 1px 4px rgba(171, 102, 93, 0.04)",
    margin: "0 6px 8px 0",
    padding: "8px 12px",
    fontWeight: 400,
    cursor: "pointer",
    "-webkit-tap-highlight-color": "transparent",
    ["&:hover"]: {
      boxShadow: "0px 3px 10px rgba(171, 102, 93, 0.21)"
    },
    ["&:focus"]: {
      backgroundColor: "white !important"
    },
    borderRadius: "23px",
    justifyContent: "center",
    ["@media (min-width:576px)"]: {
      fontSize: "17px",
      lineHeight: "20px",
      padding: "10px 16px"
    }
  },
  selectedChip: {
    background: "#FFEEEA",
    border: "2px solid #FFBBA6",
    fontWeight: "600"
  }
}));

const CustomChips = props => {
  const onChipClick = event => {
    const { panel, chipValue, chipObject, valueKey, onChipSelect } = props;
    const obj = {
      chipValue,
      panel,
      chipObject,
      valueKey,
      onChipSelect
    };
    onChipSelect(obj);
  };
  const {
    customClass,
    chipLabel,
    ChipIcon = null,
    chipObject,
    applySelectedClass = true,
    id = null
  } = props;
  const classes = useStyles();
  return (
    <div
      className={cx(
        classes.chip,
        customClass,
        applySelectedClass && chipObject.is_selected
          ? classes.selectedChip
          : null
      )}
      onClick={onChipClick}
      id={id}
    >
      {chipLabel}
      {ChipIcon}
    </div>
  );
};

export default CustomChips;
